export default "__VITE_ASSET__DkPD7fhA__"